import { render, staticRenderFns } from "./MoralPersonData.vue?vue&type=template&id=16d03f5c&scoped=true"
import script from "./MoralPersonData.vue?vue&type=script&lang=js"
export * from "./MoralPersonData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d03f5c",
  null
  
)

export default component.exports